<template>
  <div :class="$style.container">
    <div :class="$style.text">
      <div v-if="file" :class="$style.file">
        <div :class="$style.fileName">
          <div :class="$style.left">{{ leftName }}</div>
          <div :class="$style.right">{{ rightName }}</div>
        </div>
        <app-button :class="$style.deleteButton" icon="TrashIcon" @click="onClearFile" type="border" />
      </div>
      <div :class="$style.placeholder" v-else>Загрузить файл <span v-if="extensions">({{ extensions }})</span></div>
    </div>
    <input
      :class="$style.input"
      type="file"
      @change="onInputChange"
      :accept="mimes"
    />
  </div>
</template>

<script>
const presets = {
  'excel': {
    extensions: '.xls, .xlsx, .csv',
    mimes:      [
      'application/vnd.ms-excel',                                          // 'xlsx',
      'application/wps-office.xlsx',                                       // 'xlsx',
      'application/msexcel',                                               // 'xls',
      'application/x-msexcel',                                             // 'xls',
      'application/x-ms-excel',                                            // 'xls',
      'application/x-excel',                                               // 'xls',
      'application/x-dos_ms_excel',                                        // 'xls',
      'application/xls',                                                   // 'xls',
      'application/x-xls',                                                 // 'xls',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // 'xls',
      'text/csv',                                                          // 'csv',
    ],
  },
  'xlsx':  {
    extensions: '.xlsx',
    mimes:      [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/wps-office.xlsx',
    ],
  },
};

export default {
  name:     "elsaVUpload",
  props:    ['value', 'fileType'],
  data() {
    return {
      file:      null,
      fullName:  null,
      leftName:  null,
      rightName: null,
    };
  },
  computed: {
    fileName() {
      return this.file.name;
    },
    extensions() {
      const preset = presets[this.fileType];
      return preset ? preset.extensions : null;
    },
    mimes() {
      const preset = presets[this.fileType];
      return preset ? preset.mimes.join(', ') : null;
    },
  },
  methods:  {
    setFileName( file ) {
      const { name } = file;
      const splitIndex = Math.round(name.length * 0.75);

      this.fullName = name;
      this.leftName = name.slice(0, splitIndex);
      this.rightName = name.slice(splitIndex);
    },
    updateFile( file ) {
      if (file) this.setFileName(file);
      this.file = file;
    },
    setFile( file ) {
      if (file && this.fileType) {
        const preset = presets[this.fileType];
        if (preset && !preset.mimes.includes(file.type)) return;
      }

      this.updateFile(file);
      this.$emit('input', file);
    },

    onInputChange( e ) {
      const { files } = e.target;
      if (files.length) this.setFile(files[0]);
      e.target.value = '';
    },
    onClearFile() {
      this.setFile(null);
    },
  },
  watch:    {
    value( file ) {
      this.updateFile(file);
    },
  },
};
</script>

<style lang="scss" module>
$grey: #adadad;
$blue: #337ab7;
$red: #a94442;
$black: #333;

.container {
  position: relative;
  flex: 1;
  border: 1px dashed $grey;
  background: #f5f5f5;
  border-radius: 8px;
  z-index: 1;
  text-align: center;
  height: 200px;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  @include anim();

  &:hover {
    border-color: rgba(var(--vs-primary), .5);
  }
}

.text {
  display: block;
  text-align: center;
  font-weight: 700;
  white-space: nowrap;
  max-width: 100%;
  padding: 0 20px;
}

.fileName {
  display: flex;
}

.left {
  flex: 0 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre;
}

.right {
  flex: 1 0 auto;
  overflow: hidden;
  white-space: pre;
}

.input {
  position: absolute;
  opacity: 0;
  width: 200%;
  height: 200%;
  right: 0;
  bottom: 0;
  cursor: pointer;
}

.deleteButton {
  position: relative;
  z-index: 1;
}

.placeholder {
  white-space: normal;
}
</style>
